import parse from 'html-react-parser';
import Breadcrumb from '../components/Breadcrumb';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const Start = ({texts}) => {
    if ( texts.length !== 0 ) {
        const currentPath = window.location.pathname;
        const selkoPath = texts.general_selko_url ? new URL(texts.general_selko_url).pathname : null;
        const mainPath = texts.general_main_url ? new URL(texts.general_main_url).pathname : null;

        return (
            <>
                <Breadcrumb topics={[]} texts={texts} />
    
                <div className="eaut-main-content start">
                    <h1>{texts.start_title}</h1>
                    <p className="ingress">{texts.start_ingress}</p>
                    <div>{parse(texts.start_wysiwyg)}</div>
                    <div className="buttons">
                        <Link className="button" to="/topics">{texts.start_start_button_text}</Link>
                        {mainPath && currentPath !== mainPath && (
                            <Link className="button-outline" to={texts.general_main_url}>{texts.general_main_link_text}</Link>
                        )}
                        {selkoPath && currentPath !== selkoPath && (
                            <Link className="button-outline" to={texts.general_selko_url}>{texts.general_selko_link_text}</Link>
                        )}
                    </div>
                </div>

                <Footer texts={texts} />
            </>
        );
    }
};

export default Start;
